import React from "react";
import OfficeTwo from "../../assets/images/about-us/office-2.webp";
import { Link } from "react-router-dom";
import ResetLocation from "../../helpers/ResetLocation";

const AboutCareers = () => {
  return (
    <article className="about__careers">
      <section className="about__careers__content">
        <h2 className="sub-title">Karriere</h2>
        <h3>Werde Teil unseres Teams</h3>
        <p>
          Du liebst gutes Essen und erstklassigen Kundenservice? Du suchst ein dynamisches und unterstützendes Arbeitsumfeld? Casaantonio e Piccolo Giò ist immer auf der Suche nach talentierten, motivierten Menschen, die unser Team bereichern.
          Ob du bereits Erfahrung in der Gastronomie hast oder gerade erst einsteigst – wir bieten vielfältige Möglichkeiten in Bereichen wie Service, Küche und Management. Werde Teil eines Arbeitsplatzes, der Wert auf Wachstum, Teamgeist und Exzellenz in allem legt, was wir tun.
        </p>
        <Link to="/careers" onClick={ResetLocation} className="active-button-style">Join now</Link>
      </section>
      <img src={OfficeTwo} alt="" aria-hidden="true" />
    </article>
  );
}
export default AboutCareers;
